import { BlastEvent, SimulationConfig } from '../../../types';
import { drawBlastShape } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const NebulaAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  drawBlastShape(ctx, e, e.maxRadius * (1 + progress));
  ctx.fill();
};

registerBlastAnimation('NEBULA', NebulaAnimation);
